import { Surface$Surface } from '@otovo/shared/types/surfaceTypes';

export const validateScore = (surface: Surface$Surface): boolean =>
  surface.score > 0;
